"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseCpm = parseCpm;
const SECTION_START = /^START_([A-Z][A-Z0-9_]*)\s*$/;
const SECTION_END = /^END_([A-Z][A-Z0-9_]*)\s*$/;
const COMMENT_LINE = /^\s*\{[^}]*\}\s*$/;
const QUOTED_VALUE_GLOBAL = /'([^']*)'/g;
function parseCpm(content) {
    const sections = new Map();
    let current = null;
    for (const rawLine of content.split(/\r?\n/)) {
        const line = rawLine.trim();
        if (line.length === 0 || COMMENT_LINE.test(line)) {
            continue;
        }
        const startMatch = SECTION_START.exec(line);
        if (startMatch !== null) {
            current = { name: startMatch[1], entries: [] };
            sections.set(current.name, current);
            continue;
        }
        const endMatch = SECTION_END.exec(line);
        if (endMatch !== null) {
            current = null;
            continue;
        }
        if (current === null) {
            continue;
        }
        const entry = parseEntryLine(line);
        if (entry !== null) {
            current.entries.push(entry);
        }
    }
    return {
        sections,
        designName: getSingleValue(sections, 'GLOBAL', 'design_name'),
        designLibrary: getSingleValue(sections, 'GLOBAL', 'design_library'),
        libraries: getMultiValue(sections, 'GLOBAL', 'library'),
        cpmVersion: getSingleValue(sections, 'GLOBAL', 'cpm_version'),
        designDb: getSingleValue(sections, 'CANVAS', 'design_db'),
    };
}
function parseEntryLine(line) {
    const firstSpace = line.search(/\s/);
    const key = firstSpace === -1 ? line : line.slice(0, firstSpace);
    if (key.length === 0) {
        return null;
    }
    const rest = firstSpace === -1 ? '' : line.slice(firstSpace);
    const values = [];
    for (const match of rest.matchAll(QUOTED_VALUE_GLOBAL)) {
        values.push(match[1]);
    }
    return { key, values };
}
function getSingleValue(sections, sectionName, key) {
    const section = sections.get(sectionName);
    if (section === undefined) {
        return '';
    }
    for (const entry of section.entries) {
        if (entry.key === key) {
            return entry.values[0] ?? '';
        }
    }
    return '';
}
function getMultiValue(sections, sectionName, key) {
    const section = sections.get(sectionName);
    if (section === undefined) {
        return [];
    }
    for (const entry of section.entries) {
        if (entry.key === key) {
            return [...entry.values];
        }
    }
    return [];
}
//# sourceMappingURL=cpmParser.js.map